/************
 * Model Class
 * File Name ...: mail-option.components.ts
 * Generated By : ianday on 1/11/24
 * Date ........: 1/11/24
 /************/
import {ValidationResult} from './validation-result';

export interface MailOption {

    from: string;
    to: string | string[];
    cc: string | string[];
    bcc: string | string[];
    subject: string;
    text: string;
    html: string;
    attachments?: any;
}

export class MailOption {
    constructor() {
        this.from = '';
        this.to = [];
        this.cc = [];
        this.bcc = [];
        this.subject = '';
        this.text = '';
        this.html  = '';
        this.attachments = null;
    }
    public setMailOption(to: string, cc: string, subject:string, message: string): void {
        this.to = to.split(';');
        this.cc = cc.split(';');
        this.subject = subject;
        this.text = message;
    }
    validateRecord(): ValidationResult {
        const vr: ValidationResult = new ValidationResult();


        return vr;
    }
}
